import { render, staticRenderFns } from "./BalanceBank.vue?vue&type=template&id=c2ad276a&scoped=true&"
import script from "./BalanceBank.vue?vue&type=script&lang=js&"
export * from "./BalanceBank.vue?vue&type=script&lang=js&"
import style0 from "./BalanceBank.vue?vue&type=style&index=0&id=c2ad276a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ad276a",
  null
  
)

export default component.exports